// "Extra for large car" -> "extraForLargeCar": the key the store files each
// service under (reducer.js prices.byName) and the one use-live-price looks
// up, so both sides only have to agree with each other. Replaces
// lodash/camelCase (19 Oct 2026), whose Unicode word and deburr tables were
// about 8 KB of the home chunk for plain English service names
// (bin/check-bundle-size).
export const camelCase = name => String(name || '')
  .replace(/[^A-Za-z0-9]+/g, ' ')
  .trim()
  .toLowerCase()
  .replace(/ (.)/g, (_, c) => c.toUpperCase())
